import { Box, TextField, Typography } from "@mui/material";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";
import ButtonGroup from "./button-group";
import { useUser } from "../../../context/user-context";

const Wager = ({ wager, setWager }) => {
  //   const { avatarSrc, username } = racerInfo;
  const { user } = useUser();

  const buttons = [
    { label: "MIN", onClick: () => setWager(1) },
    {
      label: "1/2",
      onClick: () => setWager(Math.round(user.walletAmount / 2)),
    },
    {
      label: "1/4",
      onClick: () => setWager(Math.round(user.walletAmount / 4)),
    },
    { label: "MAX", onClick: () => setWager(user.walletAmount) },
  ];

  return (
    <>
      <Typography
        textAlign={"left"}
        color="white"
        fontSize={fontSizes.heading3}
        fontWeight={700}
      >
        Wager
      </Typography>

      <TextField
        display={"flex"}
        type="number"
        id="num"
        fullWidth
        justifyContent={"space-between"}
        height={50}
        onChange={(e) => {
          const value = e.target.value;
          if (value === "" || /^\d+(\.\d{0,1})?$/.test(value)) {
            setWager(value); // Update parent state directly
          }
        }}
        value={wager} // Set the input's value to the wager prop
        sx={{
          background: darkColors.background,
          border: "1px solid",
          borderColor: darkColors.borderGray,
          borderRadius: "12px",
          mt: 2,
          input: {
            color: "white", // Set the input text color to white
          },
        }}
        px={2}
      />
      {wager > user.walletAmount && (
        <Typography
          textAlign={"left"}
          color="red"
          variant="subtitle2"
          fontSize={fontSizes.small}
          mt={1}
        >
          Insufficient balance
        </Typography>
      )}

      {/* </Box> */}
      <Box display={"flex"} mt={1.5} gap={1}>
        <ButtonGroup buttons={buttons} />
      </Box>
    </>
  );
};
export default Wager;
